module.exports = __webpack_public_path__ + "img/success.6afdbf09.png";